import React from 'react';
import './RecruitmentContent.css';
import RECIMG from '../../assets/images/Recruitment.png'; 

const RecruitmentContent = () => {
  return (
    <section className="rec-page-content-section">
      <div className="container">
        {/* Top Intro Section */}
        <div className="rec-intro-grid">
          <div className="rec-intro-image-container">
            <img 
              src={RECIMG}
              alt="SAP Recruitment" 
              className="rec-intro-image"
            />
          </div>
          <div className="rec-intro-text">
            <h2 className="rec-intro-title">Attract and Hire the Best Talent with SAP SuccessFactors Recruitment</h2>
            <p>
              The SAP SuccessFactors Recruiting solution helps you source, engage, and hire the world's best talent. By combining intelligent technology with a mobile-first, user-friendly experience, you can transform your recruiting process from reactive to proactive.
            </p>
          </div>
        </div>

        {/* Features Grid Section */}
        <div className="rec-features-grid">
          <div className="rec-feature-card">
            <h3>Global Talent Sourcing</h3>
            <p>
              Post jobs to thousands of sources across over 80 countries and leverage a powerful sourcing engine to find the right candidates. Our solution helps you build a global talent pipeline to meet your business needs.
            </p>
          </div>
          <div className="rec-feature-card">
            <h3>Candidate Relationship Management (CRM)</h3>
            <p>
              Engage with passive and active candidates through targeted marketing campaigns and talent communities. Build and nurture relationships with top talent before you even have an open position.
            </p>
          </div>
          <div className="rec-feature-card">
            <h3>Mobile-First Candidate Experience</h3>
            <p>
              Provide a seamless and engaging application experience for candidates on any device. A simple, mobile-responsive process ensures you don't lose top talent due to a clunky application system.
            </p>
          </div>
          <div className="rec-feature-card">
            <h3>Data-Driven Hiring Insights</h3>
            <p>
              Utilize powerful analytics and reporting tools to measure and optimize every stage of your recruitment process. Make informed, data-driven decisions to improve hiring quality, speed, and cost-effectiveness.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecruitmentContent;
